import React__default from 'react';
import _default from './../external_lib/react-lottie/dist/index.js';
import { OrderStatusEnum, OrderStatusText } from '../Enums/order_status.enum.js';
import FoodReadyJson from "../assets/food-ready.animation-cf2c1b31.json";
import PreparingFoodJson from "../assets/preparing.animation-e6167a1e.json";
import { useTranslation } from 'react-i18next';
import './../external_lib/classnames/index.js';
import Typography from '../Atoms/Typography.js';
import './../external_lib/tslib/tslib.es6.js';
import '../provider.js';
import "../assets/item-card-placeholder-0f7c213a.jpg";
import './../external_lib/array-to-image/dist/index.js';
import './../external_lib/react-lazy-load-image-component/build/index.js';
import '../Utils/currency.util.js';
import 'react-dom';
import './../external_lib/@googlemaps/markerclusterer/dist/index.esm.js';
import '../Utils/color.util.js';
import './../external_lib/swiper/react/swiper.js';
import './../external_lib/swiper/react/swiper-slide.js';
import './../external_lib/swiper/core/core.js';
import './../external_lib/swiper/shared/dom.js';
import '../Utils/text.util.js';
import '../Components/Cells/CheckoutFloatingBar/Web/web.interface.js';
import 'dayjs';
import './../external_lib/react-geocode/lib/index.js';
import './../external_lib/react-google-autocomplete/lib/usePlacesAutocompleteService.js';
import '../Enums/fulfillment_type.enum.js';
import "../assets/lost-166fcc89.png";
import "../assets/transaction-9d6d85c3.png";
import "../assets/barbeque-997a871a.svg";
import '../Molecules/Confirm.js';
import '../Components/Molecules/Drawer/Web/web.interface.js';
import './OrderNowLater.js';
import '../Components/Cells/OrderStatusPreview/Web/index.shimmer.js';
import "../assets/money-a20c2c5c.png";
import './../external_lib/@googlemaps/react-wrapper/dist/index.esm.js';
import '../Molecules/Alert.js';
import '../Components/Molecules/CouponCard/common.interface.js';
import '../Molecules/FulfillmentSelector.js';
import "../assets/order-success.animation-515e4db6.json";
import "../assets/completed.animation-da5ea93a.json";
import "../assets/store-closed.animation-bedbdfa2.json";
import '../Molecules/Toast.js';
import "../assets/about-us-bg-min-7c5f45da.png";
import "../assets/google-play-06118c77.png";
import "../assets/app-store-3d6c31a5.png";
import "../assets/phone-large-629241ae.png";
import "../assets/phone-small-1c94a266.png";
import "../assets/hero-three-bg-481f9e8a.png";
import '../Components/Organisms/ItemCustomization/Web/helpers.js';
import '../Enums/item.enum.js';
import '../Components/Organisms/LoginDialog/Web/web.interface.js';
import '../Utils/npsFeedback.helper.js';
import '../Components/Organisms/PaymentMode/Web/web.interface.js';
import './../external_lib/react-datepicker/dist/index.js';

var animationOptions = {
    loop: true,
    autoplay: true,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    },
    animationData: {}
};
function OrderTracker(_a) {
    var orderStatus = _a.orderStatus, orderId = _a.orderId;
    if ([OrderStatusEnum.FoodReady, OrderStatusEnum.PreparingFood].indexOf(orderStatus) === -1) {
        return React__default.createElement(React__default.Fragment, null);
    }
    var _b = useTranslation(['translations']), t = _b.t; _b.i18n;
    var orderDetails = orderStatusHelper(t, orderStatus);
    return (React__default.createElement("div", { className: "order-tracker", style: { backgroundColor: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.backgroundColor } },
        React__default.createElement("div", { className: "order-tracker__order-id" },
            React__default.createElement("div", { className: "order-tracker__order-id__label" },
                React__default.createElement("div", { className: "order-tracker__order-id__icon", style: { background: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.iconBackground } },
                    React__default.createElement(_default, { options: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.icon, style: {
                            width: '170px',
                            position: 'absolute',
                            left: '-58px'
                        } })),
                React__default.createElement("div", { className: "order-tracker__order-id__label" },
                    React__default.createElement(Typography, { variant: "bodyTextOneMain", color: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.textColor },
                        "Order ",
                        orderId)))),
        React__default.createElement("div", { className: "order-tracker__label" },
            React__default.createElement(Typography, { variant: "bodyTextOne", color: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.textColor }, orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.label))));
}
var orderStatusHelper = function (
// eslint-disable-next-line @typescript-eslint/ban-types
t, variant) {
    try {
        switch (variant) {
            case OrderStatusEnum.PreparingFood:
                animationOptions.animationData = PreparingFoodJson;
                return {
                    label: t(OrderStatusText.PreparingFood),
                    icon: animationOptions,
                    textColor: '#B0790E',
                    backgroundColor: '#FFFBF3',
                    iconBackground: '#FAAC14'
                };
            case OrderStatusEnum.FoodReady:
                animationOptions.animationData = FoodReadyJson;
                return {
                    label: t(OrderStatusText.FoodReady),
                    icon: animationOptions,
                    textColor: '#006b12',
                    backgroundColor: '#F2FDF0',
                    iconBackground: '#00C853'
                };
            default:
                return null;
        }
    }
    catch (err) {
        console.log(err);
    }
};

export { OrderTracker as default };
//# sourceMappingURL=OrderTracker.js.map
